module.exports = __webpack_public_path__ + "static/track-your-shipment-show-your-delivery-status-c6974ad2d0e8a9997f38a1edeb5246c9.png";